import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import Quiz from '../../components/Quiz';
import quizBg from '../../../../../../assets/sme/tpv/topic2-quiz-bg.png';
import SenderVerification from '../../components/SenderVerification';
import FourPartIllustration from '../../../../../../assets/sme/tpv/FourPartIllustration.png';
import WhySmeTargetReasons from '../../components/WhySmeTargetReasons';
interface ISection1Props {
  settings: any;
}

const Section2: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '4';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const updateComponentState = useUpdateComponentState();
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[3],
    [settings?.paragraphs]
  );
  const quiz = paragraphsSettings?.quiz;
  const handleSenderVerificationComplete = React.useCallback(() => {
    updateComponentState(p_course, p_topic, ID, 'sme-tpv-section3-1');
  }, [updateComponentState, p_course, p_topic, ID]);

  return (
    <div className="topic-section-3">
      <div className="WhySmeTargetContent">
        <div className="WhySmeTargetContent-title">
          {paragraphsSettings?.title}
        </div>
        <div className="WhySmeTargetContent-desc">
          {paragraphsSettings?.description}
        </div>
        <WhySmeTargetReasons
          title={paragraphsSettings?.subTitle}
          description={paragraphsSettings?.subDescription}
          items={paragraphsSettings?.tetralogyList}
        />
      </div>

      <SenderVerification
        title={paragraphsSettings?.senderVerificationData?.title}
        steps={paragraphsSettings?.senderVerificationData?.steps}
        id="sme-tpv-section3-1"
        onComplete={handleSenderVerificationComplete}
        imgBg={FourPartIllustration}
      />
      <div id="sme-tpv-section3-question" className="topic-quiz">
        <Quiz
          title={paragraphsSettings?.questionTitle}
          description={quiz?.description}
          question={quiz?.question}
          options={quiz?.options}
          quizImg={quizBg}
          onCompleted={() => {
            updateComponentState(
              p_course,
              p_topic,
              ID,
              'sme-tpv-section3-question'
            );
          }}
        />
      </div>
    </div>
  );
};

export default Section2;
